import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';

import { replace } from 'connected-react-router';

import routes from 'utils/routes';

import { actions as orderActions } from 'state/order';
import { selectors as errorsSelectors } from 'state/errors';
import { userIsAuthenticatedRedir } from 'components/auth/hoc';

import { constants as aditionalOptionsConstants } from 'utils/aditionalOptions';

import Summary from 'pages/Summary/styled';

const enhance = compose(
  connect(
    (state) => ({
      hasError:
        !!errorsSelectors.getErrors(state)[
          aditionalOptionsConstants.ADITIONAL_OPTIONS.INSURANCE
        ],
    }),
    {
      replaceRoute: replace,
      onCheck: orderActions.checkAditionalOption,
      onValueChange: orderActions.setAditionalOption,
      checkPaymentMethod: orderActions.checkPaymentMethod,
    }
  ),
  withHandlers({
    handleBack:
      ({ replaceRoute, onCheck, hasError }) =>
      () => {
        if (hasError) {
          onCheck({
            type: aditionalOptionsConstants.ADITIONAL_OPTIONS.INSURANCE,
            shipmentKey: 'FIRST_SHIPMENT',
            value: false,
          });
        }
        replaceRoute(routes.newOrder);
      },
  }),
  lifecycle({
    componentDidMount() {
      const { checkPaymentMethod } = this.props;
      checkPaymentMethod();
    },
  }),
  userIsAuthenticatedRedir
);

export default enhance(Summary);
